import {Nullable} from '../../app/TypeHelpers'
import NewFacilityCommon, {
    OptionSettingForNewFacility,
    ReservationSettingsForNewFacility,
    ServerImageInformation,
} from './NewFacilityCommon'

export interface BusinessSchedule {
    businessScheduleUnit: string
    dateStraddle: Nullable<string>
    joinPrevDaysSchedule: Nullable<string>
    startTime: Nullable<string>
    endTime: Nullable<string>
    charge: Nullable<number>
    chargeUnit: Nullable<string>
    chargeUnitTime: Nullable<number>
    changedChargeApplyStartTime: Nullable<number>
    changedChargeApplyStartTimeUnit: Nullable<string>
    changedCharge: Nullable<number>
    changedChargeUnit: Nullable<string>
    changedChargeUnitTime: Nullable<number>
}

export interface ReservationTimeSection {
    startTime: string
    maxReservationTime: number
}

export interface MaxReservationTimeSetting {
    allDayMaxReservationTime: Nullable<number>
    reservationTimeSections: ReservationTimeSection[]
}

export default class NewFacilityForDurationRental extends NewFacilityCommon {
    businessSchedules: BusinessSchedule[]
    maxReservationTimeSetting: MaxReservationTimeSetting

    constructor(
        sortOrder: number,
        categoryId: string | null,
        equipmentIds: number[],
        facilityName: string,
        accessControlManager: string | null,
        cardKeyFacilityNumber: string | null,
        gateNumbers: string[] | null,
        images: ServerImageInformation[],
        facilityIntroductory: string,
        optionSettings: OptionSettingForNewFacility[],
        reservationSetting: ReservationSettingsForNewFacility,
        releaseSetting: string,
        releaseStartDate: Nullable<string>,
        releaseStartTime: Nullable<string>,
        reserveBeforeCleaningTime: number,
        reserveAfterCleaningTime: number,
        businessSchedules: BusinessSchedule[],
        maxReservationTimeSetting: MaxReservationTimeSetting,
    ) {
        super(sortOrder,
            categoryId,
            equipmentIds,
            facilityName,
            accessControlManager,
            cardKeyFacilityNumber,
            gateNumbers,
            images,
            facilityIntroductory,
            optionSettings,
            reservationSetting,
            releaseSetting,
            releaseStartDate,
            releaseStartTime,
            reserveBeforeCleaningTime,
            reserveAfterCleaningTime,
        )

        this.businessSchedules = businessSchedules
        this.maxReservationTimeSetting = maxReservationTimeSetting
    }
}
